import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';

interface BackButtonProps {
  to?: string;
  children?: React.ReactNode;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  to = '/',
  children = 'Home',
  className = '',
}) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={`inline-flex items-center gap-x-1.5 rounded-full bg-white px-3 py-1.5 text-sm
        font-semibold text-gray-900 shadow-sm ring-1 z-10 ring-inset ring-gray-300
        hover:bg-gray-50 absolute mt-4 ml-4 ${className}`}
      onClick={() => navigate(to)}
    >
      <ArrowLeftIcon className="size-5" /> {children}
    </button>
  );
};
